import $ from "jquery";
import "../main/utils/vportal.js";

// Expose jQuery globally for CDN scripts
window.jQuery = window.$ = $;

// Load twbsPagination CDN dynamically after jQuery is exposed
var loadTwbsPagination = function (callback) {
  var script = document.createElement("script");
  script.src =
    "https://cdnjs.cloudflare.com/ajax/libs/twbs-pagination/1.4.2/jquery.twbsPagination.min.js";
  script.onload = function () {
    callback();
  };
  script.onerror = function () {
    console.error("❌ Failed to load twbsPagination CDN");
  };
  document.head.appendChild(script);
};

// function truncateToOneLine(element) {
//   const originalText = element.textContent.trim();
//   element.textContent = originalText;

//   const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
//   const maxHeight = lineHeight * 1.1;

//   // Truncate character by character
//   let text = originalText;
//   let iterations = 0;
//   const maxIterations = originalText.length;

//   while (text.length > 0 && iterations < maxIterations) {
//     if (element.scrollHeight > maxHeight) {
//       text = text.substring(0, text.length - 1);
//       element.textContent = text + "...";
//     } else {
//       break;
//     }
//     iterations++;
//   }
// }

window.addEventListener("load", function () {
  // Truncate all news text to 1 line
  // setTimeout(() => {
  //   const newsTexts = document.querySelectorAll(".news-text");
  //   newsTexts.forEach((el) => {
  //     truncateToOneLine(el);
  //   });
  // }, 100); // Small delay for CSS to render
  loadTwbsPagination(function () {
    $(".news").each(function () {
      var postsTag = "#" + $(this).attr("id");

      // Call vPortal on the jQuery object, not empty selector
      $(postsTag).vPortal({
        container: postsTag,
        el: {
          tabContainer: ".news-tabs > a",
          resultContainer: ".news-list",
          viewAll: ".viewAll",
        },
        paginationOptions: {},
      });
    });
  });
});
